import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { supabase } from '../../../lib/supabase';
import Icon from '../../../components/AppIcon';

const NewsMetrics = () => {
  const { user } = useAuth();
  const [metrics, setMetrics] = useState({
    totalArticles: 0,
    publishedArticles: 0,
    draftArticles: 0,
    totalViews: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user) {
      fetchMetrics();
    }
  }, [user]);

  const fetchMetrics = async () => {
    try {
      setLoading(true);

      // Fetch all news articles for the provider
      const { data: articles, error } = await supabase?.from('provider_news')?.select('status, view_count')?.eq('provider_id', user?.id);

      if (error) throw error;

      const published = articles?.filter(a => a?.status === 'published')?.length || 0;
      const draft = articles?.filter(a => a?.status === 'draft')?.length || 0;
      const totalViews = articles?.reduce((sum, a) => sum + (a?.view_count || 0), 0);

      setMetrics({
        totalArticles: articles?.length || 0,
        publishedArticles: published,
        draftArticles: draft,
        totalViews,
      });
    } catch (error) {
      console.error('Error fetching metrics:', error);
    } finally {
      setLoading(false);
    }
  };

  const metricCards = [
    {
      label: 'Totaal Artikelen',
      value: metrics?.totalArticles,
      icon: 'FileText',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      label: 'Gepubliceerd',
      value: metrics?.publishedArticles,
      icon: 'FileCheck',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      label: 'Concepten',
      value: metrics?.draftArticles,
      icon: 'FileEdit',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
    },
    {
      label: 'Totaal Weergaven',
      value: metrics?.totalViews,
      icon: 'Eye',
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card border border-border rounded-lg p-6 animate-pulse">
            <div className="h-4 bg-muted rounded w-1/2 mb-4"></div>
            <div className="h-8 bg-muted rounded w-3/4"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metricCards?.map((metric) => (
        <div
          key={metric?.label}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-elevation-2 transition-shadow"
        >
          <div className="flex items-center justify-between mb-4">
            <div className={`p-3 rounded-lg ${metric?.bgColor}`}>
              <Icon name={metric?.icon} size={24} className={metric?.color} />
            </div>
          </div>
          <p className="text-sm text-muted-foreground mb-1">{metric?.label}</p>
          <p className="text-3xl font-bold text-foreground">{metric?.value}</p>
        </div>
      ))}
    </div>
  );
};

export default NewsMetrics;